import React from 'react';
import { translate } from '@utils/i18n';
import { Tooltip } from '@ui/atoms/Tooltip';
import { Button } from '@ui/atoms/Button';
const namespace = 'features.inspections_answer_by_type';
export function ReportCell({ row, isSub, hasWarning, languageCodes, defaultLanguage, showExcludeUntested, showGroupBySection }) {
    if (row.report_text != null) {
        return React.createElement("span", { className: "qmb-status" }, row.report_text);
    }
    if (row.disabled) {
        return (React.createElement(Tooltip, { content: row.tooltip_text, position: "right" },
            React.createElement(Button, { variant: "secondary", disabled: true },
                React.createElement("i", { className: "fa-regular fa-file-lines", "aria-hidden": "true" }),
                translate('report_cell.generate_report', { namespace }))));
    }
    if (!row.report_url)
        return null;
    const reportAttrs = {
        'data-report-name': row.name,
        'data-report-type': 'partial',
        'data-language-codes': JSON.stringify(languageCodes),
        'data-default-language': defaultLanguage,
        'data-show-exclude-untested': showExcludeUntested,
        'data-show-group-by-section': showGroupBySection,
        'data-has-warning': hasWarning
    };
    const linkClass = `qmb-ui-button qmb-ui-button--secondary${isSub ? ' is-sub-excluded' : ''}`;
    const needsOptionsModal = languageCodes.length > 1 || showGroupBySection;
    if (needsOptionsModal) {
        return (React.createElement("a", Object.assign({ href: row.report_url, className: linkClass, "data-js-generate-report-modal-trigger": true }, reportAttrs),
            React.createElement("i", { className: "fa-regular fa-file-lines", "aria-hidden": "true" }),
            translate('report_cell.generate_report', { namespace })));
    }
    if (hasWarning) {
        return (React.createElement("a", Object.assign({ href: row.report_url, className: linkClass, "data-js-confirmation-modal-trigger": true, "data-link": row.report_url, "data-needs-confirm": "true" }, reportAttrs),
            React.createElement("i", { className: "fa-regular fa-file-lines", "aria-hidden": "true" }),
            translate('report_cell.generate_report', { namespace })));
    }
    return (React.createElement("a", { href: row.report_url, className: linkClass },
        React.createElement("i", { className: "fa-regular fa-file-lines", "aria-hidden": "true" }),
        translate('report_cell.generate_report', { namespace })));
}
